import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api/api.service';
import { MySettings } from 'src/app/pages/entities/my-settings/my-settings.model';
import { MySettingsLocalService } from 'src/app/pages/entities/my-settings/my-settings-local.service';
import { Account } from 'src/model/account.model';
import { AccountService } from './account.service';

const AUTHENTICATION_TOKEN = 'jhi-authenticationtoken';

@Injectable({
  providedIn: 'root',
})
export class AuthServerProvider {
  constructor(
    private http: HttpClient,
    private mySettingsService: MySettingsLocalService,
    private accountService: AccountService,
  ) {}

  getToken() {
    return JSON.parse(localStorage.getItem(AUTHENTICATION_TOKEN) ?? sessionStorage.getItem(AUTHENTICATION_TOKEN));
  }

  login(credentials): Observable<any> {
    const data = {
      username: credentials.username,
      password: credentials.password,
      rememberMe: credentials.rememberMe,
    };

    return this.http.post(ApiService.API_URL + '/authenticate', data, { observe: 'response' }).pipe(map(authenticateSuccess.bind(this)));

    function authenticateSuccess(resp) {
      const bearerToken = resp.headers.get('Authorization');
      if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
        const jwt = bearerToken.slice(7, bearerToken.length);
        this.storeAuthenticationToken(jwt, credentials.rememberMe);
        return jwt;
      }
    }
  }

  loginWithToken(jwt, rememberMe) {
    if (jwt) {
      this.storeAuthenticationToken(jwt, rememberMe);
      return Promise.resolve(jwt);
    } else {
      return Promise.reject('auth-jwt-service Promise reject'); // Put appropriate error message here
    }
  }

  storeAuthenticationToken(jwt, rememberMe) {
    jwt = JSON.stringify(jwt);
    if (rememberMe) {
      localStorage.setItem(AUTHENTICATION_TOKEN, jwt);
      this.storeAuthentication();
    } else {
      sessionStorage.setItem(AUTHENTICATION_TOKEN, jwt);
    }
  }

  logout(): Observable<any> {
    return new Observable(observer => {
      localStorage.removeItem(AUTHENTICATION_TOKEN);
      // localStorage.removeItem('businessName');
      sessionStorage.removeItem(AUTHENTICATION_TOKEN);
      observer.complete();
    });
  }

  async storeAuthentication(): Promise<void> {
    let mySetting: MySettings = await this.mySettingsService.findOneByKey('authenticated');
    if (mySetting) {
      mySetting.myValue = 'true';
      this.mySettingsService.update(mySetting);
    } else {
      mySetting = {
        myKey: 'authenticated',
        myValue: 'true',
      };
      this.mySettingsService.save(mySetting);
    }
  }

  async removeAuthentication(): Promise<void> {
    let mySetting: MySettings = await this.mySettingsService.findOneByKey('authenticated');
    if (mySetting) {
      mySetting.myValue = 'false';
      this.mySettingsService.update(mySetting);
    } else {
      mySetting = {
        myKey: 'authenticated',
        myValue: 'false',
      };
      this.mySettingsService.save(mySetting);
    }
    this.removeAccountInformation();
  }

  async storeAccountInformation(account: Account): Promise<void> {
    const done: boolean = await this.accountService.clearTableLocal();
    if (done) {
      this.accountService.saveLocal(account);
    } else {
      this.removeAuthentication();
    }
  }

  removeAccountInformation(): void {
    this.accountService.clearTableLocal();
  }

  async getLocalAccountInformation(): Promise<Account> {
    const accounts: Account[] = await this.accountService.findAllLocal();
    if (accounts.length > 0) {
      return accounts[0];
    } else {
      this.removeAuthentication();
      return null;
    }
  }
}
